export default {
	'pajoohyar.appName': 'پژوهیار',
	'general.etAl': 'و دیگران',
	'general.back': 'بازگشت',
	'general.thanksForHelpingImprove': 'از اینکه به بهبود %S کمک می‌کنید، سپاسگزاریم!',
	'general.tryAgain': 'دوباره تلاش کنید',
	'general.updateAvailable': 'به‌روزرسانی موجود است',
	'general.copyToClipboard': 'رونوشت در کلیپ‌بورد',
	'general.finished': 'تمام شد',
	'general.checkForUpdates': 'بررسی به‌روزرسانی‌ها',
	'general.keys.cmdShift': 'Cmd+Shift+',
	'general.clear': 'پاک کردن',
	'general.failed': 'ناموفق',
	'general.restartLater': 'بعداً راه‌اندازی مجدد',
	'general.unknownErrorOccurred': 'خطای ناشناخته‌ای رخ داد.',
	'general.dontShowAgainFor': 'امروز دیگر نمایش نده؛برای %1$S روز دیگر نمایش نده',
	'general.permissionDenied': 'دسترسی ممنوع',
	'general.checkForUpdate': 'بررسی به‌روزرسانی',
	'general.moreInformation': 'اطلاعات بیشتر',
	'general.quitApp': 'خروج از %S',
	'general.errorHasOccurred': 'خطایی رخ داده است.',
	'general.and': 'و',
	'general.isUpToDate': '%S به‌روز است.',
	'general.seeForMoreInformation': 'برای اطلاعات بیشتر به %S مراجعه کنید.',
	'general.success': 'موفقیت',
	'general.submitted': 'ارسال شده',
	'general.character.plural': 'کاراکترها',
	'general.locate': 'یافتن…',
	'general.restartNow': 'اکنون راه‌اندازی مجدد',
	'general.pleaseRestart': 'لطفاً %S را راه‌اندازی مجدد کنید.',
	'general.quit': 'خروج',
	'general.hide': 'پنهان کردن',
	'general.browserIsOffline': '%S در حال حاضر در حالت آفلاین است.',
	'general.error': 'خطا',
	'general.import': 'وارد کردن',
	'general.warning': 'هشدار',
	'general.yes': 'بله',
	'general.useDefault': 'استفاده از پیش‌فرض',
	'general.fix': 'رفع…',
	'general.restartRequiredForChanges': 'برای اعمال تغییرات باید پژوهیار راه‌اندازی مجدد شود.',
	'general.accessDenied': 'دسترسی رد شد',
	'general.continue': 'ادامه',
	'general.dontShowAgain': 'دیگر نمایش نده',
	'general.copy': 'کپی',
	'general.keys.ctrlShift': 'Ctrl+Shift+',
	'general.create': 'ایجاد',
	'general.export': 'صادر کردن',
	'general.noUpdatesFound': 'هیچ به‌روزرسانی‌ای یافت نشد',
	'general.restartRequired': 'نیاز به راه‌اندازی مجدد',
	'general.actionCannotBeUndone': 'این عمل قابل بازگشت نیست.',
	'general.pdf': 'PDF',
	'general.remove': 'حذف',
	'general.cancel': 'انصراف',
	'general.tryLater': 'بعداً تلاش کنید',
	'general.operationInProgress.waitUntilFinishedAndTryAgain': 'لطفاً تا پایان عملیات صبر کنید و دوباره تلاش کنید.',
	'general.processing': 'در حال پردازش',
	'general.disable': 'غیرفعال کردن',
	'general.restartApp': 'راه‌اندازی مجدد %S',
	'general.enable': 'فعال کردن',
	'general.showDirectory': 'نمایش پوشه',
	'general.passed': 'قبول شد',
	'general.invalidResponseServer': 'پاسخ نامعتبر از سرور.',
	'general.reset': 'بازنشانی',
	'general.nMegabytes': '%S مگابایت',
	'general.numMore': '%S بیشتر…',
	'general.serverError': 'سرور خطا داد. لطفاً دوباره تلاش کنید.',
	'general.upgrade': 'ارتقا',
	'general.open': 'باز کردن %S',
	'general.openPreferences': 'باز کردن تنظیمات',
	'general.describeProblem': 'مشکل را به‌طور مختصر شرح دهید:',
	'general.pleaseRestartAndTryAgain': 'لطفاً %S را راه‌اندازی مجدد کرده و دوباره تلاش کنید.',
	'general.operationInProgress.waitUntilFinished': 'لطفاً تا پایان عملیات صبر کنید.',
	'general.dontShowWarningAgain': 'این هشدار دیگر نمایش داده نشود.',
	'general.notNow': 'فعلاً نه',
	'general.item': 'مورد',
	'general.restartRequiredForChange': 'برای اعمال تغییر باید پژوهیار راه‌اندازی مجدد شود.',
	'general.character.singular': 'کاراکتر',
	'general.operationInProgress': 'عملیات پژوهیار در حال انجام است.',
	'general.no': 'خیر',
	'general.delete': 'حذف',
	'general.openDocumentation': 'باز کردن مستندات',
	'general.tryAgainLater': 'لطفاً چند دقیقه بعد دوباره تلاش کنید.',
	'general.install': 'نصب',
	'general.yellow': 'زرد',
	'general.red': 'قرمز',
	'general.green': 'سبز',
	'general.blue': 'آبی',
	'general.purple': 'بنفش',
	'general.orange': 'نارنجی',
	'general.magenta': 'صورتی',
	'general.gray': 'خاکستری',
	'general.showInLibrary': 'نمایش در کتابخانه',
	'general.insert': 'درج',
	'noteEditor.blockquote': 'نقل قول بلوکی',
	'noteEditor.mathBlock': 'بلوک ریاضی',
	'noteEditor.italic': 'ایتالیک',
	'noteEditor.cut': 'برش',
	'noteEditor.orderedList': 'لیست شماره‌دار',
	'noteEditor.alignCenter': 'وسط چین',
	'noteEditor.replaceNext': 'جایگزینی',
	'noteEditor.bulletList': 'لیست گلوله‌ای',
	'noteEditor.replaceAll': 'جایگزینی همه',
	'noteEditor.showItem': 'نمایش مورد',
	'noteEditor.heading1': 'عنوان 1',
	'noteEditor.leftToRight': 'چپ به راست',
	'noteEditor.enterLink': 'وارد کردن لینک',
	'noteEditor.paste': 'چسباندن',
	'noteEditor.insertCitation': 'درج استناد',
	'noteEditor.copy': 'کپی',
	'noteEditor.bold': 'بولد',
	'noteEditor.heading3': 'عنوان 3',
	'noteEditor.editInWindow': 'ویرایش در پنجره جداگانه',
	'noteEditor.previous': 'قبلی',
	'noteEditor.returnToNotesList': 'بازگشت به فهرست یادداشت‌ها',
	'noteEditor.updateNotice': 'این یادداشت با نسخه جدیدتری از %1$S ویرایش شده است.\nلطفاً %1$S را به‌روزرسانی کنید تا تغییرات اعمال شود.',
	'noteEditor.heading2': 'عنوان 2',
	'noteEditor.findAndReplace': 'یافتن و جایگزینی',
	'noteEditor.monospaced': 'تک‌فاصله',
	'noteEditor.insertLink': 'درج لینک',
	'noteEditor.align': 'تراز',
	'noteEditor.showOnPage': 'نمایش در صفحه',
	'noteEditor.addCitation': 'افزودن استناد',
	'noteEditor.removeCitation': 'پنهان کردن استناد',
	'noteEditor.alignRight': 'راست چین',
	'noteEditor.replace': 'جایگزین',
	'noteEditor.annotationsWithDate': 'حاشیه‌نویسی‌ها (%S)',
	'noteEditor.alignLeft': 'چپ چین',
	'noteEditor.clearFormatting': 'پاک کردن قالب‌بندی',
	'noteEditor.unlink': 'حذف لینک',
	'noteEditor.goToPage': 'رفتن به صفحه',
	'noteEditor.underline': 'زیرخط',
	'noteEditor.next': 'بعدی',
	'noteEditor.more': 'بیشتر',
	'noteEditor.set': 'تنظیم',
	'noteEditor.paragraph': 'پاراگراف',
	'noteEditor.editCitation': 'ویرایش استناد',
	'noteEditor.rightToLeft': 'راست به چپ',
	'noteEditor.find': 'یافتن',
	'noteEditor.formatText': 'قالب‌بندی متن',
	'noteEditor.highlightText': 'برجسته‌سازی متن',
	'noteEditor.textColor': 'رنگ متن',
	'noteEditor.removeColor': 'حذف رنگ',
	'noteEditor.strikethrough': 'خط خوردگی',
	'noteEditor.subscript': 'زیرنویس',
	'noteEditor.superscript': 'بالانویس',
	'noteEditor.edit': 'ویرایش',
	'noteEditor.applyAnnotationColors': 'اعمال رنگ‌های حاشیه‌نویسی',
	'noteEditor.removeAnnotationColors': 'حذف رنگ‌های حاشیه‌نویسی',
	'noteEditor.addCitations': 'نمایش استنادهای حاشیه‌نویسی',
	'noteEditor.removeCitations': 'مخفی کردن استنادهای حاشیه‌نویسی',
	'noteEditor.image': 'تصویر',
	'noteEditor.math': 'ریاضی',
	'noteEditor.table': 'جدول',
	'noteEditor.insertRowBefore': 'درج ردیف بالا',
	'noteEditor.insertRowAfter': 'درج ردیف پایین',
	'noteEditor.insertColumnBefore': 'درج ستون چپ',
	'noteEditor.insertColumnAfter': 'درج ستون راست',
	'noteEditor.deleteRow': 'حذف ردیف',
	'noteEditor.deleteColumn': 'حذف ستون',
	'noteEditor.deleteTable': 'حذف جدول',
	'noteEditor.insertImage': 'درج تصویر',
	'noteEditor.insertTable': 'درج جدول',
	'noteEditor.insertMath': 'درج بلوک ریاضی',
};
